import React, { useEffect, Suspense, lazy } from "react";
import { useSelector } from "react-redux";
// Below are the import components
// Common Imports
import Login from "../../NCPWebsite/Pages/Login/Login";
import CommonPage from "./NCLLayout"; // contains header and outlet placeholder
// Student
import Assessment from "../Student/Assessment/Assessment";
import Instructions from "../Student/Assessment/Instructions";
import Ansewersheet from "../Student/Assessment/Answersheet";
import AssFeedBack from "../Student/Assessment/AssessmentFeedback";
import Results from "../Student/Assessment/Results";
import Resultss from "../Student/Assessment/Resultss";
import BadgeDetails from "../Student/Badges/BadgesDetails";
import ASDetails from "../Student/PerformanceReport/AnswerSheet/AnswersheetDetails";
import ViewAnswerSheet from "../Student/PerformanceReport/AnswerSheet/ViewAnswerSheet";
import Dashboard from "../Student/Assessment/Dashboard";
import QuestionRating from "../Student/PerformanceReport/AnswerSheet/QuestionRating";
import StudentFeedback from "../Student/PerformanceReport/StudentFeedback";
import PerformanceTrends from "../Student/PerformanceReport/PerformanceTrends";
import ReportCard from "../Student/ReportCard/ReportCard";
// Samagra
import SamagraLo from "../Student/Samagra/SamagraLo";
import SamagraAnswersheet from "../Student/Assessment/SamagaraAnswersheet";

import SamagaraReportCard from "../Student/ReportCard/SamagraReportCard";

// Teacher
import TDashboard from "../Teacher/Dashboard/Dashboard";
import TeachDiffLevel from "../Teacher/TeacherDifflevel";
import PerformanceEachStudent from "../Teacher/PerformanceEachStudent";
// import BulkUpload from "../Teacher/Registration/BulkUpload";
import AutobulkRegistrations from "../Teacher/Registration/AutobulkRegistrations";
// import StudentInformation from "../Teacher/Registration/StudentInformation";
// import StudentDetails from "../Teacher/Registration/StudentDetails";
import CustomErroPage from "../Student/Reusablecomponents/CustomErrorPage";
import TeacherResults from "../Teacher/Results/TeacherResults";
import StudentwiseR from "../Teacher/Results/SWResults";
import AttendanceReport from "../Teacher/Results/AttendanceReport";

//Principle
import PrincipleDashboard from "../Principle/PrincipleDashboard";
import PrinciplePerformance from "../Principle/PrinciplePerformance";
import PrincipleParticipation from "../Principle/PrincipleParticipation";
// import PrincipleReportCard from "../Principle/PrincipleReportCard";
import PrincipleAnswerSheetDetails from "../Principle/PrincipleAnswerSheetDetails";
import PReportCard from "../Principle/ReportCard/PReportCard";
//Whatapp links
import SchoolPerformance from "../Whatsapp/SchoolPerformance";
import SchoolParticipation from "../Whatsapp/SchoolParticipation";
import SSPRCardSchool from "../Whatsapp/SSPRCardSchool";

// Below is for samagra Dashboard
import PSamagraLayout from "../Principle/SamagraDashboard/PSamagraLayout";
import Participation from "../Principle/SamagraDashboard/Participation/Participation";
import SamagraPerformance from "../Principle/SamagraDashboard/SamagraPerformance";
import QPerformance from "../Principle/SamagraDashboard/CircularAnalysis/QPerformance";
import StudentDirectory from "../Principle/SamagraDashboard/StudentDirectory/StudentDirectory";
import SamagaraStudent from "../Principle/SamagraDashboard/SamagraStudent";
// HQ Pages
// import Participationtable from "../InstitutionAdmin/Participation";
// import PerformanceTable from "../InstitutionAdmin/Performance/Performance";
// import RegionPerformanceDrillDown from "../InstitutionAdmin/Performance/RegionPerformanceDrillDown";
// import StatePerformanceDrillDown from "../InstitutionAdmin/Performance/StatePerformanceDrillDown";
// import DistrictPerformanceDrillDown from "../InstitutionAdmin/Performance/DistrictPerformanceDrillDown";
// import HQStudentwiseR from "../InstitutionAdmin/Performance/HQSWResults";
// import HQViewAnswerSheet from "../InstitutionAdmin/Performance/ViewAnswerSheet";
// import HQLoPerformanceReport from "../InstitutionAdmin/Performance/LoPerformanceReport";
// import HQSchoolPerformance from "../InstitutionAdmin/Performance/SchoolPerformance/Dashboard/Dashboard";
// import HQSDiffLevel from "../InstitutionAdmin/Performance/SchoolPerformance/TeacherDifflevel";
// import HQSPerformanceEachStudent from "../InstitutionAdmin/Performance/SchoolPerformance/PerformanceEachStudent";
// QB Admin
//Question Bank
// import QuestionBank from "../QBAdmin/QuestionBank";
// import Scenario from "../QBAdmin/QuestionBank/MathScenario/ScenarioList";
// import AddEditScenario from "../QBAdmin/QuestionBank/MathScenario/AddEditScenario";
// import ScenarioQuestions from "../QBAdmin/QuestionBank/MathScienceQuestions/AddQuestions/ScenarioQuestions";
// import AddUpdateQuestions from "../QBAdmin/QuestionBank/MathScienceQuestions/AddQuestions/AddUpdateQuestions";
// import DirectQuestions from "../QBAdmin/QuestionBank/MathsDirectQuestions/DirectQuestions";
// import PreviewQuestion from "../QBAdmin/QuestionBank/Preview";
// import InputBasedQuestions from "../QBAdmin/QuestionBank/MathsIBQuestions/IBQuestions";
// import CloneAddQuestion from "../QBAdmin/QuestionBank/MathScienceQuestions/AddQuestions/CloneAddQuestion";
// English QB Admin
// import EnglishQB from "../QBAdmin/QuestionBank/English";
// import EScenario from "../QBAdmin/QuestionBank/English/EnglishScenario/EScenarioList";
// import EDirectQuestions from "../QBAdmin/QuestionBank/English/DirectQuestions";
// import EInputBasedQuestions from "../QBAdmin/QuestionBank/English/IBQuestions";
// import EAddEditScenario from "../QBAdmin/QuestionBank/English/EnglishScenario/AddEditEScenario";
// import ScenarioEnglishQuestions from "../QBAdmin/QuestionBank/English/EnglishScenario/ScenarioEnglishQuestions";
// import AddUpdatEngQuestions from "../QBAdmin/QuestionBank/English/AddUpdatEnglishQuestions";
// import EnglishFilters from "../QBAdmin/QuestionBank/English/QBEnglishFilters/EnglishFilters";

// import QBVerify from "../QBAdmin/OverallDashboard/QBVerifyStatus";

// import QuestionStatus from "../QBAdmin/QuestionStatus";
// import Qstatus from "../QBAdmin/QuestionStatus/QStatus";

// import FilterSQ from "../QBAdmin/QuestionBank/FilterScenarioQuestions/FilterSQ";
// import QBDashboard from "../QBAdmin/OverallDashboard/QBDashboard";
// import OverallDashboard from "../QBAdmin/OverallDashboard";

// import ProgressTracker from "../QBAdmin/ProgressTracker";
// import PTracker from "../QBAdmin/ProgressTracker/PTracker";
// import ProgressDrillDown from "../QBAdmin/ProgressTracker/ProgressDrillDown";

// import ReviewQuestions from "../QBAdmin/ReviewQuestions/ReviewQuestions";

import Rmaterial from "../QBAdmin/QuestionBank/Remediation";

// import QBAQuestionStatusTrack from "../QBAdmin/QuestionStatusTrack/QuestionStatusTrack"
// Below are QbScience Filters pages
// import ScienceFilters from "../QBAdmin/QuestionBank/FilterScience/Sciencefilters";

// Below is langugae translater page
// import TranslateScenario from "../QBAdmin/QuestionBank/MathScenario/TranslateScenario";
// import TranslateQuestion from "../QBAdmin/QuestionBank/MathScienceQuestions/AddQuestions/TranslateQuestion";
// NCL Admin
import QuestionPaper from "../ReusableComponents/QuestionPaper";
import OMRQuestionPaper from "../ReusableComponents/OMRQuestionPaper";


// import DownloadStudentResponses from "../NCLAdmin/StudentResponses";
// import OMRUPloadfile from "../NCLAdmin/OMRAnswers/UPloadFile";

// import QBReports from "../NCLAdmin/QBReports";

// import Assessments from "../NCLAdmin/WeeklySodhanaTests/Assessments";
// import WeeklyTests from "../NCLAdmin/WeeklySodhanaTests/WeeklyTests";
// import AddTest from "../NCLAdmin/WeeklySodhanaTests/AddWeeklyTests";
// import PreviewQuestionPaper from "../NCLAdmin/WeeklySodhanaTests/PreviewQuestionPaper";
// import Schools from "../NCLAdmin/Masters/Schools";
// import AddSchool from "../NCLAdmin/Masters/AddSchool";

// import AssessmentParticipationReport from "../NCLAdmin/AssessmentParticipation/AssessmentParticipationReport";
// import OverallWeeklyQuestions from "../NCLAdmin/QBReports/OverallWeeklyQuestions";
// import QuestionStatusTrack from "../NCLAdmin/QBReports/QuestionStatusTrack";
// import AssessmentQuestionPaper from "../NCLAdmin/WeeklySodhanaTests/AssessmentQuestionPaper";

import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useIdleTimer } from "react-idle-timer";

import { ClearSession } from "../ReusableComponents/CommonFunctions";
// import InstituteHierarchy from "../NCLAdmin/Institutes/InstituteHierarchy";
// import Institution from "../NCLAdmin/Institutes/Institution";
// import QBAdminLogin from "../NCLAdmin/QBAdminLogin/QBAdminLogin";
// import Parameters from "../NCLAdmin/Parameters/AssessmentParameters";

// Below is for Home Pages
import NCPLayout from "../../NCPWebsite/ReUableComponents/NCPLayout";
import Home from "../../NCPWebsite/Pages/Home/Home";
import CBLerning from "../../NCPWebsite/Pages/CBLerning/CBLerning";
import Teams from "../../NCPWebsite/Pages/Teams";
import PhotoGallery from "../../NCPWebsite/Pages/Gallery/PhotoGallary";
import VideoGallery from "../../NCPWebsite/Pages/Gallery/VideoGallery";
import YearBrochures from "../../NCPWebsite/Pages/Gallery/Brochures";
import AnnualReports from "../../NCPWebsite/Pages/Gallery/AnnualReports";
import Donate from "../../NCPWebsite/Pages/Donate";
// import LandingPage from "../../NCPWebsite/Pages/PracticeLogin/LandingPage";
// import PracticeAssessment from "../../NCPWebsite/Pages/PracticeLogin/Assessment";

// Below is for Home Pages

// Below import NCP Teach
import DownloadStudentResponsesTech from "../NCPTech/StudentResponsesTech";

import HQAdminRoutes from "./Routes/HQAdminRoutes";
import NCLAdminRoutes from "./Routes/NCLAdminRoutes";
import QBAdminRoutes from "./Routes/QBAdminRoutes";

import PLogin from "../../PracticeAssessments/PracticeLogin/PLogin";
import PracticeTestLayout from "../../PracticeAssessments/Reusabality/PracticeTestLayout";
import InputPracticeTest from "../../PracticeAssessments/InputPracticetest";
import StudentReport from "../../PracticeAssessments/StudentReport";
import PracticeAssessment from "../../PracticeAssessments/PracticeAssessment";
import Practiceresults from "../../PracticeAssessments/Practiceresults";
const LoPerformanceReport = lazy(() =>
  import("../Student/PerformanceReport/LoPerformanceReport")
);
const StudentDetails = lazy(() =>
  import("../Teacher/Registration/StudentDetails")
);



const NCLRoutes = () => {
  const navigate = useNavigate();
  const items = useSelector(
    (state) => state.userDetailsData.LoginDetails.userTypeId
  );
  const LoginDetails = useSelector(
    (state) => state.userDetailsData.LoginDetails
  );
  const AssessmentData = JSON.parse(localStorage.getItem("AssessmentData"));

  const location = useLocation();
  const onIdle = () => {
    alert("Your session has been expired. Please re-login");
    navigate("/login");
    sessionStorage.clear();
    localStorage.clear();
  };
  useIdleTimer({
    onIdle,
    timeout: 20 * 60 * 1000,
  });

  const Navigation = (Details) => {
    switch (Details) {
      case 10:
        return <Navigate replace to="/InstitutionAdmin" />;
      case 8:
        return <Navigate replace to="/InstitutionAdmin" />;
      case 7:
        return <Navigate replace to="/QBAdmin/QuestionBank" />;
      case 4:
        return <Navigate replace to="/Student" />;
      case 3:
        return <Navigate replace to="/TeacherDashboard" />;
      case 2:
        return <Navigate replace to="/PrincipleDashboard" />;
      case 1:
        return <Navigate replace to="/NCLAdmin/StudentResponses" />;
    }
  };

  const useQuery = () => {
    return new URLSearchParams(location.search);
  };
  const query = useQuery();
  const contestCreationId = query.get("CId");
  const schoolId = query.get("SId");
  const assessmentType = query.get("AType");
  const Sname = query.get("SchoolName") || "";
  useEffect(() => {
    if (localStorage.getItem("Clearstorage")) {
      ClearSession();
    }
  }, []);
  return (
    <>
      <Routes>
        {/* Below is for home pages routes */}
        <Route path="/" element={<NCPLayout />}>
          <Route index element={<Home />} />
          <Route path="/Competency Base Learning" element={<CBLerning />} />
          <Route path="/NCP Teams" element={<Teams />} />
          <Route path="/PhotoGallery" element={<PhotoGallery />} />
          <Route path="/VideoGallery" element={<VideoGallery />} />
          <Route path="/Donate" element={<Donate />} />
          <Route path="/Brochures" element={<YearBrochures />} />
          <Route path="/AnnualReports" element={<AnnualReports />} />
          <Route path="/Login" element={<Login />} />
          {/* <Route path="/PracticeLogin" element={<PLogin />} /> */}
          {/* <Route path="/LandingPage" element={<LandingPage />} /> */}
          {/* <Route path="/PracticeAssessment" element={<PracticeAssessment />} />
          <Route path="/PracticeResults" element={<Practiceresults />} /> */}
        </Route>
        {/* Above is for home pages routes */}


        <Route path="/PracticeTest" element={<PracticeTestLayout />}>
          <Route index element={<PLogin />} />
          <Route path="/PracticeTest/PracticeLogin" element={<PLogin />} />
          <Route path="/PracticeTest/TestSelection" element={LoginDetails?.Name ? <InputPracticeTest /> : <Navigate replace to="/PracticeTest/PracticeLogin" />} />
          <Route path="/PracticeTest/TestReports" element={LoginDetails?.Name ? <StudentReport /> : <Navigate replace to="/PracticeTest/PracticeLogin" />} />
          <Route path="/PracticeTest/PracticeAssessment" element={LoginDetails?.Name ? <PracticeAssessment /> : <Navigate replace to="/PracticeTest/PracticeLogin" />} />
          <Route path="/PracticeTest/PracticeResults" element={LoginDetails?.Name ? <Practiceresults /> : <Navigate replace to="/PracticeTest/PracticeLogin" />} />

        </Route>

        <Route index element={!!items ? Navigation(items) : <Login />} />
        <Route
          path="/*"
          element={
            !!items ? <CustomErroPage /> : <Navigate replace to="/login" />
          }
        />

        {items === 4 && (
          <>

            <Route
              path="/PerformanceTrends"
              element={
                !!items ? <CommonPage /> : <Navigate replace to="/login" />
              }
            >
              <Route index element={<PerformanceTrends />} />
            </Route>
            <Route
              path="/AssessmentBadges"
              element={
                !!items ? <CommonPage /> : <Navigate replace to="/login" />
              }
            >
              <Route index element={<BadgeDetails />} />
            </Route>

            <Route
              path="/ReportCard"
              element={
                !!items ? <CommonPage /> : <Navigate replace to="/login" />
              }
            >
              <Route index element={<ReportCard />} />
              <Route path="/ReportCard/Samagara" element={<SamagaraReportCard />} />
            </Route>

            <Route
              path="/Feedback"
              element={
                !!items ? <CommonPage /> : <Navigate replace to="/login" />
              }
            >
              <Route index element={<StudentFeedback />} />
            </Route>
            <Route
              path="/Student"
              element={
                !!items ? <CommonPage /> : <Navigate replace to="/login" />
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="/Student/Assessment" element={<Assessment />} />
              <Route path="/Student/Instructions" element={<Instructions />} />
              <Route
                path="/Student/Answersheet"
                element={
                  // AssessmentData?.assessmentType === 3 &&
                  //   LoginDetails?.grade <= 10 ? (
                  <SamagraAnswersheet />
                  // ) : (
                  //   <Ansewersheet />
                  // )
                }
              />
              <Route path="/Student/Results" element={<Results />} />
              {/* <Route path="/Student/Results" element={LoginDetails?.grade < 11 ? <Results /> : <Resultss />} /> */}
              <Route path="FeedBack" element={<AssFeedBack />} />
            </Route>
          </>
        )}
        <Route
          path="/LoPerformanceReport"
          element={!!items ? <CommonPage /> : <Navigate replace to="/login" />}
        >
          {/* <Route index element={<SodhanaPerformanceReport />} /> */}
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <LoPerformanceReport />
              </Suspense>
            }
          />
          <Route
            path="/LoPerformanceReport/Remediation"
            element={<Rmaterial />}
          />
        </Route>
        <Route
          path="/Samagra"
          element={
            !!items ? <CommonPage /> : <Navigate replace to="/login" />
          }
        >
          <Route path="LoPerformance" element={<SamagraLo />} />
        </Route>
        <Route
          path="/ViewAnswerSheetDetails"
          element={!!items ? <CommonPage /> : <Navigate replace to="/login" />}
        >
          <Route index element={<ASDetails />} />
          <Route path="ViewAnswerSheet" element={<ViewAnswerSheet />} />
          <Route path="QuestionRating" element={<QuestionRating />} />
          {/* <Route path="Question Paper" element={<QuestionPaper />} /> */}
          <Route path="Question Paper" element={<OMRQuestionPaper />} />
        </Route>

        {(items === 3 || items === 2) && (
          <Route
            path="/TeacherDashboard"
            element={
              !!items ? <CommonPage /> : <Navigate replace to="/login" />
            }
          >
            <Route
              index
              element={
                !!items ? <TDashboard /> : <Navigate replace to="/login" />
              }
            />
            <Route
              path="/TeacherDashboard/TeacherDifficultyLevel"
              element={<TeachDiffLevel />}
            />
            <Route
              path="/TeacherDashboard/PerformanceByeachSubject"
              element={<PerformanceEachStudent />}
            />

            <Route
              path="/TeacherDashboard/StudentInformation/StudentDetails"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <StudentDetails />{" "}
                </Suspense>
              }
            />

            {/* <Route
              path="/TeacherDashboard/StudentInformation/BulkUpload"
              element={<BulkUpload />}
            /> */}
            <Route
              path="/TeacherDashboard/StudentInformation/AutobulkRegistrations"
              element={<AutobulkRegistrations />}
            />
            <Route
              path="/TeacherDashboard/StudentInformation/Results/AssessmentResults"
              element={<TeacherResults />}
            />
            <Route
              path="/TeacherDashboard/StudentInformation/AttendanceResults/AttendanceReport"
              element={<AttendanceReport />}
            />
            <Route
              path="/TeacherDashboard/StudentInformation/Results/Studentwiseresults"
              element={<StudentwiseR />}
            />
            {/* <Route
              path="/TeacherDashboard/StudentInformation/Results/QuestionPaper"
              element={<QuestionPaper />}
            /> */}
            <Route
              path="/TeacherDashboard/StudentInformation/Results/QuestionPaper"
              element={<OMRQuestionPaper />}
            />
            {/* <Route
              path="/TeacherDashboard/ScienceQuestionBank/ScienceQuestion"
              element={<ScienceQuestion />}
            /> */}
          </Route>
        )}
        {items === 2 && (
          <>
            <Route
              path="/PrincipleDashboard"
              element={
                !!items ? <CommonPage /> : <Navigate replace to="/login" />
              }
            >
              <Route index element={<PrincipleDashboard />} />
            </Route>
            <Route
              path="/PrinciplePerformance"
              element={
                !!items ? <CommonPage /> : <Navigate replace to="/login" />
              }
            >
              <Route index element={<PrinciplePerformance />} />
            </Route>
            <Route
              path="/PrincipleParticipation"
              element={
                !!items ? <CommonPage /> : <Navigate replace to="/login" />
              }
            >
              <Route index element={<PrincipleParticipation />} />
            </Route>{" "}
            <Route
              path="/Principle/PrincipleReportCard"
              element={
                !!items ? <CommonPage /> : <Navigate replace to="/login" />
              }
            >
              <Route index element={<PReportCard />} />
              {/* <Route index element={<PrincipleReportCard />} /> */}
            </Route>{" "}
            <Route
              path="/Principle/PrincipleAnswerSheetDetails"
              element={
                !!items ? <CommonPage /> : <Navigate replace to="/login" />
              }
            >
              <Route index element={<PrincipleAnswerSheetDetails />} />
            </Route>


            <Route path="/Principle/SamagraDashboard"
              element={!!items ? <CommonPage /> : <Navigate replace to="/login" />} >

              <Route path="Participation" element={<PSamagraLayout />}>
                <Route index element={<Participation />} />
              </Route>

              <Route path="Performance" element={<PSamagraLayout />}>
                <Route index element={<SamagraPerformance />} />
              </Route>

                <Route path="CircularAnalysis" element={<PSamagraLayout />}>
                <Route index element={<QPerformance />} />
              </Route>

                <Route path="Directory" element={<PSamagraLayout />}>
                <Route index element={<StudentDirectory />} />
              </Route>

                <Route path="SAMAGRAStudent" element={<PSamagraLayout />}>
                <Route index element={<SamagaraStudent />} />
              </Route>

            </Route>
          </>
        )}
        {(items === 10 || items === 8) && (HQAdminRoutes(items))}

        {items === 1 && NCLAdminRoutes(items)}

        {items === 7 && (QBAdminRoutes(items, LoginDetails))}

        <Route path="/SchoolPerformance" element={
          <SchoolPerformance contestCreationId={contestCreationId}
            schoolId={schoolId} assessmentType={assessmentType} />} />
        <Route path="/SchoolParticipation" element={
          <SchoolParticipation contestCreationId={contestCreationId}
            schoolId={schoolId} assessmentType={assessmentType} />} />

        <Route path="/School/ReportCard" element={
          <SSPRCardSchool contestCreationId={contestCreationId} SchoolName={Sname}
            schoolId={schoolId} assessmentType={assessmentType} />} />

        {items === 1 && (
          <Route path="/NCPTech" element={
            !!items ? <CommonPage /> : <Navigate replace to="/login" />
          }>
            <Route index element={<DownloadStudentResponsesTech />} />
          </Route>
        )}
      </Routes>
    </>
  );
};
export default NCLRoutes;